<template>
    <el-row>
        <el-col :span="span">
            <el-table :data="tableData" v-loading="loading" :empty-text="$t('common.message.noData')" border stripe style="width: 100%" :height="height" @row-click="handleRowClick">
                <!-- 动态列 -->
                <el-table-column
                    v-for="column in columns"
                    :key="column.prop"
                    :prop="column.prop"
                    :label="column.label"
                    :min-width="column.width"
                    :align="column.align || 'center'"
                    :fixed="column.fixed"
                />
            
                <!-- 操作列 -->
                <el-table-column
                    v-if="showBtn"
                    label="操作"
                    :width="btnWidth"
                    fixed="right"
                    align="left"
                >
                    <template #default="scope">
                        <slot name="action" :row="scope.row"></slot>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页条 -->
            <el-pagination
                v-if="pagination"
                class="pagination"
                background
                layout="prev, pager, next, sizes, total"
                :current-page="pagination.currentPage"
                :page-size="pagination.pageSize"
                :total="pagination.total"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
            >
            <template #total>
                {{ $t('common.pagination.total', { total: pagination.total }) }}
            </template>
            </el-pagination>
        </el-col>
    </el-row>
  </template>
  
  <script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    // 表格数据
    tableData: {
        type: Array,
        required: true,
    },
    span: {
        type: Number,
        default: 24,
    },
    height: {
        type: Number,
        default: 200,
    },
    // 动态列配置
    columns: {
        type: Array,
        required: true,
    },
    // 是否显示操作列
    showBtn: {
        type: Boolean,
        default: false,
    },
    // 操作列宽度
    btnWidth: {
        type: String,
        default: '100',
    },
    // 分页数据
    pagination: {
        type: Object,
        default: null, // { currentPage: 1, pageSize: 10, total: 0 }
    },
    loading: {
        type: Boolean,
        default: false,
    }
  });

  const emit = defineEmits(['row-click', 'page-change', 'size-change']);

  // 处理行点击事件
  const handleRowClick = (row) => {
    emit('row-click', row);
  };
  // 处理分页页码变化
const handlePageChange = (page) => {
    emit('page-change', page);
};
// 处理分页大小变化
const handleSizeChange = (size) => {
    emit('size-change', size);
};
</script>

<style>
.pagination {
    margin-top: 10px;
    justify-content: right;
}
.el-loading-mask {
  background-color: transparent !important;
}
:deep(.cell) {
    padding: 0 3px !important;
}

</style>